import script from "./sw-item-parts-select.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-select.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-select.vue?vue&type=style&index=0&id=20f1d756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f1d756"]])

export default __exports__